var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateStoreTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7984 7.86419L7.3123 2.89944L7.26004 2.825H7.16908H3H2.66326L2.85679 3.10057L8.24368 10.7713L2.86858 16.8844L2.6131 17.175H3H4.235H4.31417L4.36644 17.1155L8.99829 11.8462L12.6877 17.1006L12.74 17.175H12.8309H17H17.3367L17.1432 16.8994L11.5558 8.94081L16.6773 3.11555L16.9327 2.825H16.5459H15.3109H15.2317L15.1795 2.88441L10.7984 7.86419ZM9.78384 10.7501L9.78376 10.7499L9.22913 9.97445L9.22909 9.97441L5.02055 4.08603H6.48756L9.99218 8.98989L9.99234 8.99013L10.5445 9.76543L10.5447 9.76566L14.9701 15.9584H13.5031L9.78384 10.7501Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateStoreTwitter);
export default __webpack_public_path__ + "static/media/affiliate-store-twitter.6801b121933f7e7b2d3ef0c178055b95.svg";
export { ForwardRef as ReactComponent };